import { Helmet } from 'react-helmet'
import scrollSmoothTo from '../../components/Functionals/Smooth'
import MenuShare from './MenuShare'
import Disclaimer from './Disclaimer'
import menuLink from '../../DinnerMenu.pdf'
import menuImage from '../../assets/images/menuDinnerEvent1.png'
import menuImage2 from '../../assets/images/menuDinnerEvent2.png'
import dishImage from '../../assets/images/dinnerImage.jpg'

export default function DinnerMenu(){
  return (
    <div className="pageStyles dinner-menu">
      <Helmet>
        <title>Enjoy Dinner at Villaggio Grille</title>
        <meta name="description" content="Make your taste buds feel like royalty one bite at a time. Our dinner menu is full of incredible pasta, steaks, and seafood." />
      </Helmet>

      <div id="menupage" className="nodrops">
        <div id="page-title" className="pt-bkg-image image-menus">
          <div className="overlay">
            <div className="title-container less">
              <section className="fancy-heading center">
                <h1>Dinner Menu</h1>
              </section>
            </div>
          </div>
        </div>

        <div className="fullSec ipNav">
          <button onClick={() => scrollSmoothTo("mainMenu")} title="Dinner Menu">Dinner Menu</button>
          <button onClick={() => scrollSmoothTo("kids")} title="Kids Menu">Kids Menu</button>
          <button onClick={() => scrollSmoothTo("dessert")} title="Dessert Menu">Dessert Menu</button>
          <button onClick={() => scrollSmoothTo("familyMeals")} title="Family Meals To Go">Family Meals To Go</button>
        </div>

        <div className="page-content food-menus">
          <div className="fullSec newLay">
            <div className="kpWrapXl">
              <div className="right cbp-item">
                <div id="mainMenu" className="cbp-caption second">
                  <div className="cbp-caption-defaultWrap"><h4>Dinner Menu</h4></div>

                  <div className="cbp-caption-activeWrap">
                    <div className="cbp-l-caption-body menuLink">
                      <p className="instr">Click the menu image below to see a larger version.</p>
                      <a href={menuLink} target="_blank" rel="noopener noreferrer" className="menu-item menuImg">
                        <img src={menuImage} alt="Villaggio dinner appetizers" className="border" />
                        <img src={menuImage2} alt="Villaggio dinner entrèes" className="border" />
                      </a>
                    </div>
                  </div>
                </div>

                <MenuShare />
              </div>

              <div className="left stickyNn fwImage">
                <img src={dishImage} alt="Italian fusion dinner dishes in Orange Beach, AL" />
              </div>

              <div className="clearfix"></div>
              <Disclaimer />

              <div className="mobImage"><img src={dishImage} alt="Italian fusion menu in Orange Beach, AL" /></div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
